module.exports = __webpack_public_path__ + "static/media/blockchain.67034046.svg";